/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-22T14:38:13+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-23T13:10:57+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AInputRadioText from 'common/inputs/components/AInputRadioText';
import {i18nInterface} from '../../../utilities/i18n_common';
import {createNumberFormatter} from '../masks/numberMask';
import OInputFieldGroup from '../containers/OInputFieldGroup';
import {requireString} from '../containers/validators';
import MInputGroupRadioText from './MInputGroupRadioText';
import MPositionFormChildrenCheckout from '../../../checkout/components/MPositionFormChildrenCheckout';
import {isKfx} from '../../../config/constants.common';

/**
 * MSumCalculatorCheckout - …
**/


const formatCurrencyPrecise = createNumberFormatter({
  prefix: '',
  suffix: ' €',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  requireDecimal: true,
  allowNegative: false,
});


class MSumCalculatorCheckout extends Component {
  render() {
    const {
      name,
      info,
      value,
      showErrors,
      modelPaymentConditions,
      paymentConditions,
    } = this.props;

    if (isKfx()) {
      return (
        <div className="m-sum-calculator-checkout clearfix">
          <div className="m-sum-calculator-checkout__name">
            <div className="m-sum-calculator-checkout__name-text">{name}</div>
            <div className="m-sum-calculator-checkout__name-info">{info}</div>
          </div>
          <div className="m-sum-calculator-checkout__value">{value}</div>
        </div>
      );
    }

    const paymentConditionsEl =
      ( <div className={'m-sum-calculator-checkout__container'}>
        <OInputFieldGroup
          model={modelPaymentConditions}
          component={MInputGroupRadioText}
          validators={{
            required: requireString,
          }}
          messages={{
            required: i18nInterface('error.missing.objective.' +
                      'paymentConditions'),
          }}
          showErrors={showErrors}
          label={'Welche Zahlweise bevorzugen Sie?'}
          description={'Im Falle einer Kündigung erhalten Sie zu viel gezahlte Beiträge selbstverständlich zurück.'}
        >

          <AInputRadioText htmlValue={'12'}>
                    Monatlich: {paymentConditions ?
                    formatCurrencyPrecise(
                        parseFloat(paymentConditions['12']['rate_per_payment'])) :
                    ' ...'}
          </AInputRadioText>
          <AInputRadioText htmlValue={'1'}>
                    Jährlich: {paymentConditions ?
                    formatCurrencyPrecise(
                        parseFloat(paymentConditions['1']['rate_per_year'])) :
                    ' ...'}
            <br/>
            {paymentConditions &&
                      <span
                        className="a-format a-format-address"
                      >
                        {i18nInterface('label.payment.means') +
                            `${formatCurrencyPrecise(
                                parseFloat(paymentConditions['1']['rate_per_year']) /
                              12)} ${paymentConditions['12']['i18n_adverb']}.`}
                      </span>
            }
          </AInputRadioText>
        </OInputFieldGroup>
        <div className="a-text a-text-input-description">
          {info}
        </div>
      </div>
      );


    return (
      <MPositionFormChildrenCheckout>
        {paymentConditionsEl}
      </MPositionFormChildrenCheckout>
    );
  }
}

MSumCalculatorCheckout.propTypes = {
  info: PropTypes.string.isRequired,
  /**
   * show errors for input fields on ...
   * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
   */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  paymentConditions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  /**
   * react-redux-form model
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
   */
  modelPaymentConditions: PropTypes.string.isRequired,
};
MSumCalculatorCheckout.defaultProps = {
  info: '* Es entstehen KEINE versteckten Gebühren und Kosten.',
  showErrors: true,
};
export default MSumCalculatorCheckout;

